import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router';
import { App } from '@/App';
import { AuthProvider } from '@/auth/AuthContext';
import { UpdateBanner } from '@/components/UpdateBanner';
import './styles.css';

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Elemento #root não encontrado em index.html');
}

createRoot(rootElement).render(
  <StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <App />
        <UpdateBanner />
      </AuthProvider>
    </BrowserRouter>
  </StrictMode>,
);
